import { render, staticRenderFns } from "./PelletsGuideCarousel.vue?vue&type=template&id=70a39967&scoped=true"
import script from "./PelletsGuideCarousel.vue?vue&type=script&lang=ts"
export * from "./PelletsGuideCarousel.vue?vue&type=script&lang=ts"
import style0 from "./PelletsGuideCarousel.vue?vue&type=style&index=0&id=70a39967&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a39967",
  null
  
)

export default component.exports